module.exports = __webpack_public_path__ + "341cc69fefe7ab7f3bc590861d557a62.fbx";